@use '../../ui-library/styles/border' as border;
@use '../../ui-library/styles/icon' as icon;
@use '../../ui-library/styles/mixins' as mixins;
@use '../../ui-library/styles/surface' as surface;
@use '../../ui-library/styles/tag' as tag;
@use '../../ui-library/styles/text' as text;
@use '../../ui-library/styles/typography' as typography;

$fade-distance: 40px;

@mixin ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdownMenu {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 380px;
  max-height: min(513px, var(--radix-popover-content-available-height));
  padding: 8px 0 0 !important;
  overflow: hidden;
  border-color: border.$border-default !important;
  border-radius: 12px !important;
}

.menuHeader {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 6px 16px;
}

.menuTitle {
  @include typography.text-m-medium;
  color: text.$text-primary;
  margin: 0;
}

.divider {
  flex-shrink: 0;
  height: border.$border-width;
  margin: 0 14px;
  border-radius: border.$border-width;
  background-color: border.$border-default;
}

.notificationsList {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-height: 0;
  padding: 0 8px 8px;
  overflow-x: hidden;
  overflow-y: auto;

  &.fadeTop:not(.fadeBottom) {
    mask-image: linear-gradient(to bottom, transparent 0, black $fade-distance, black 100%);
  }

  &.fadeBottom:not(.fadeTop) {
    mask-image: linear-gradient(to bottom, black 0, black calc(100% - #{$fade-distance}), transparent 100%);
  }

  &.fadeTop.fadeBottom {
    mask-image: linear-gradient(
      to bottom,
      transparent 0,
      black $fade-distance,
      black calc(100% - #{$fade-distance}),
      transparent 100%
    );
  }
}

.notificationItem {
  all: unset;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 4px;
  width: 100%;
  padding: 8px;
  border-radius: 10px;
  text-align: left;
  transition: opacity 150ms ease-out;

  @starting-style {
    opacity: 0;
  }
}

.skeletonDate {
  flex: none;
  margin-left: auto;
}

.clickable {
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: surface.$surface-default;
  }

  &:focus-visible {
    @include mixins.focus-ring;
    outline-offset: -2px;
  }
}

.itemHeader {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.avatar {
  @include typography.text-xs-semibold;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 28px;
  height: 28px;
  border-radius: 9999px;

  @each $colour, $background, $foreground in ('blue' tag.$tag-blue-background tag.$tag-blue-default),
    ('purple' tag.$tag-purple-background tag.$tag-purple-default),
    ('green' tag.$tag-green-background tag.$tag-green-default),
    ('orange' tag.$tag-orange-background tag.$tag-orange-default),
    ('cyan' tag.$tag-cyan-background tag.$tag-cyan-default),
    ('crimson' tag.$tag-crimson-background tag.$tag-crimson-default),
    ('yellow' tag.$tag-yellow-background tag.$tag-yellow-default),
    ('amber' tag.$tag-amber-background tag.$tag-amber-default), ('red' tag.$tag-red-background tag.$tag-red-default),
    ('grey' tag.$tag-grey-background tag.$tag-grey-default)
  {
    &[data-colour='#{$colour}'] {
      background-color: $background;
      color: $foreground;
    }
  }
}

.message {
  @include typography.text-m-regular;
  @include ellipsis;
  flex: 1;
  min-width: 0;
  color: text.$text-secondary;
}

.username {
  @include typography.text-m-medium;
  color: text.$text-primary;
}

.date {
  @include typography.text-s-regular;
  flex: none;
  white-space: nowrap;
  color: text.$text-secondary;
}

.itemBody {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 36px;
  box-sizing: border-box;
}

.card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
  padding: 8px;
  overflow: hidden;
  background-color: surface.$surface-default;
  border: border.$border-width solid border.$border-default;
  border-radius: 8px;
}

.cardIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 20px;
  height: 20px;
  color: icon.$icon-secondary;
}

.cardDetails {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.cardTitle {
  @include typography.text-m-medium;
  @include ellipsis;
  color: text.$text-primary;
}

.cardType {
  @include typography.text-s-regular;
  @include ellipsis;
  color: text.$text-secondary;
}
